import React, { PropsWithChildren } from 'react';
import { Filter, JoinCondition, Aggregation } from '@models/feature-descriptor';
import { EditorTemplateRenderer } from './EditorTemplateRenderer';
import { isSet } from '@utils';

export const EditorWrapper = (
  props: PropsWithChildren<{
    selectedType:
      | Filter.Type
      | JoinCondition.Type
      | Aggregation.Type
      | undefined;
    templates: JSX.Element[];
    selectorWidth: number;
  }>
) => {
  const [isSummaryVisible, setIsSummaryVisible] = React.useState(() =>
    isSet(props.selectedType)
  );

  return (
    <div style={{ display: 'flex' }}>
      <div
        style={{ display: 'inline-flex', height: '26px', alignItems: 'center' }}
      >
        {isSummaryVisible ? (
          <span
            className="inline-displayed-value"
            onClick={() => setIsSummaryVisible(false)}
          >
            {props.selectedType}
          </span>
        ) : (
          <span
            style={{ width: `${props.selectorWidth}px`, marginTop: '6px' }}
            onBlur={() => {
              setIsSummaryVisible(true);
            }}
          >
            {props.children}
          </span>
        )}
      </div>
      <EditorTemplateRenderer templates={props.templates} />
    </div>
  );
};
